import { datadogRum } from '@datadog/browser-rum';
import config, { getEnvironmentName } from '../config';

const initializeDatadogRUM = () => {
  const environment = getEnvironmentName();

  if (environment === 'production') {
    datadogRum.init({
      applicationId: config.DATADOG_APPLICATION_ID,
      clientToken: config.DATADOG_APPLICATION_ID,
      site: 'datadoghq.com',
      service: 'signup-funnel',
      env: 'production',
      version: '1.0.0',
      sessionSampleRate: 100,
      trackResources: true,
      trackLongTasks: true,
      trackUserInteractions: true,
      trackViewsManually: true,
      defaultPrivacyLevel: 'mask-user-input',
    });

    datadogRum.startSessionReplayRecording();
  }
};

export default initializeDatadogRUM;
